// extracted by mini-css-extract-plugin
module.exports = {"container":"HB","disabled":"IB","remove":"JB"};